var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.DatasetAsImage,{attrs:{"path":_setup.props.args.path,"history-dataset-id":_setup.props.args.history_dataset_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }